import React, {FunctionComponent, HTMLProps} from "react";
import styles from "./CloseButton.module.scss";

const CloseButton: FunctionComponent<HTMLProps<HTMLSpanElement>> = (props) => {
    return <span className={styles.closeButton} {...props} />;
};

export default CloseButton;
